import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import { Box, Button, styled, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import axios from 'axios';
import { addDays, format, subDays } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import sendNotification from '../utils/sendNotification';
import ErrorLoading from '../components/BasicComponents/ErrorLoading';
import HistoryTable from '../components/HistoryTable';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import ProfileWarning from '../components/Profile/ProfileWarning';
import { updateStatus as updateAvailStatus } from '../redux/AvailabilitySlice';
import {
    fetchSchoolBooking,
    fetchTeacherBooking,
    updateStatus,
} from '../redux/BookingSlice';
import SignSchoolDocs from '../components/BasicComponents/SignSchoolDocs';

const validPermission = 'read:booking';

const RootDiv = styled('div')(({ theme }) => ({
    padding: '30px 20px 40px',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const History = () => {
    // const classes = useStyles();
    let history = useHistory();

    const [state, setState] = useState({
        grade: '',
        address: '',
        teacherName: '',
        teacherProfile: '',
        skills: '',
        otherSkills: '',
        bio: '',
        addDates: '',
        value1: false,
        value2: true,
        openSnack: false,
        snackBarMessage: '',
        snackSeverity: 'success',
        startDate: format(subDays(Date.now(), 60), 'yyyy-MM-dd'),
        endDate: format(addDays(Date.now(), 60), 'yyyy-MM-dd'),
    });

    const [redirectToHome, setRedirectToHome] = useState(false);

    const [countDown, setCountDown] = useState(20);

    const [signDocsOpen, setSignDocsOpen] = useState(false);
    const [schoolDocsInfo, setSchoolDocsInfo] = useState({});
    const [cached, setCached] = useState({});

    //0 === not applied, 1 === postive, 2 === negative

    const { booking } = useSelector(state => state.booking);
    const bookingStatus = useSelector(state => state.booking.status);
    const bookingSource = useSelector(state => state.booking.bookingSource);

    const profile = useSelector(state => state.profile.profile);
    const tokenStatus = useSelector(state => state.token.status);
    const profileStatus = useSelector(state => state.profile.status);
    const { token } = useSelector(state => state.token);
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        //useEffect is completed on page load
        //Service to get the profile for a user
        console.log(
            'status of profile ' + profileStatus + ' ' + profile.Data.Count
        );
        // if (profileStatus === 'idle') {
        //     async function dispatchProfileFromStore() {
        //         const token = await getAccessTokenSilently({
        //             scope: process.env.REACT_APP_scope,
        //         });

        //         dispatch(storeToken(token));
        //         dispatch(fetchProfile(token));
        //     }
        //     dispatchProfileFromStore();
        // }
        if (profileStatus === 'succeeded' && profile.Data.Count === 0) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileStatus, dispatch]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setRedirectToHome(true);
        }
    }, [tokenStatus, token.Count, token.permissions]);

    async function dispatchBookingFromStore(scope, type) {
        console.log('Item Called', scope, type);
        const token = await getAccessTokenSilently({
            scope: scope,
        });
        if (type === 'Teacher') {
            dispatch(
                fetchTeacherBooking({
                    token: token,
                    date1: state.startDate,
                    date2: state.endDate,
                    location: 'History',
                })
            );
        } else if (type === 'School') {
            dispatch(
                fetchSchoolBooking({
                    token: token,
                    date1: state.startDate,
                    date2: state.endDate,
                    location: 'History',
                })
            );
        }
    }

    useEffect(() => {
        console.log('Running Use Effect');
        console.log(
            bookingSource !== 'History',
            bookingStatus,
            profile.Data.Count
        );
        if (bookingStatus === 'succeeded' || bookingStatus === 'idle') {
            if (bookingSource !== 'History' && profile.Data.Count > 0) {
                dispatchBookingFromStore(
                    process.env.REACT_APP_scope,
                    profile.Data.Items[0].type
                );
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getAccessTokenSilently,
        bookingSource,
        bookingStatus,
        profile.Data.Count,
        dispatch,
    ]);

    useEffect(() => {
        console.log('run x times');
        if (redirectToHome) {
            setTimeout(() => {
                var interimNumber = countDown - 1;
                setCountDown(interimNumber);
            }, 1000);
        }
    }, [redirectToHome, countDown]);

    const handleSearch = () => {
        if (profile.Data.Count > 0) {
            dispatchBookingFromStore(
                process.env.REACT_APP_scope,
                profile.Data.Items[0].type
            );
        }
    };

    let rows = [];
    if (profileStatus === 'succeeded' && profile.Data.Count > 0) {
        if (profile.Data.Items[0].type === 'School') {
            rows = booking.Data.filter(row => {
                if (row.status !== 'Reserved') {
                    return row;
                }
                return false;
            });
        } else if (
            profile.Data.Items[0].type === 'Teacher' &&
            profile.Data.Count > 0
        ) {
            rows = booking.Data.map(row => {
                return row;
            });
        }
    }

    //sortedRows = rows.sort((a, b) => (a.status < b.status ? 1 : -1));
    //const sortedCompletionRows = completedRows.sort((a, b) => (a.start < b.status ? 1 : -1));

    const confirmBooking = async (event, approve, row) => {
        // Memoized function
        if (approve === undefined) {
            event = cached.event;
            approve = cached.approve;
            row = cached.row;
        }

        event.stopPropagation();
        console.log('index item ' + JSON.stringify(row));
        const originalStatus = row.status;
        let changeStatus = { status: 'Processing', id: row.uniqueId };
        dispatch(updateStatus(changeStatus));

        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        const data = {
            'request': { 'approve': approve.toString(), 'date': row.sk1 },
        };

        const response = await axios
            .put('/confirmBooking', data.request, {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: '/confirmBooking',
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(response => {
                changeStatus.status = response.data.Message.Data.bookingStatus;
                dispatch(updateStatus(changeStatus));
                try {
                    const availStatus = {
                        status: response.data.Message.Data.availStatus,
                        id: response.data.Message.Data.availUniqueId,
                    };
                    dispatch(updateAvailStatus(availStatus));
                } catch {
                    console.log('Availability not in memory');
                }

                if (response.data.Message.Code === 'Awaiting Sign') {
                    setSchoolDocsInfo({
                        docs: response.data.Message.Data.results,
                        logo: row.schoolLogo,
                        name: row.schooName,
                    });
                    setSignDocsOpen(true);
                    setCached({
                        event: event,
                        approve: approve,
                        row: row,
                    });
                } else {
                    sendNotification('success', 6000, 'Booking Updated');
                }
            })
            .catch(err => {
                changeStatus.status = originalStatus;
                dispatch(updateStatus(changeStatus));
                console.log('Alert Customer of Failure');

                sendNotification('error', 0, 'Booking Failed to Update');
                // setState({
                //     ...state,
                //     snackBarMessage: 'Booking Failed to Update',
                //     openSnack: true,
                //     snackSeverity: 'error',
                // });
            });
        console.log('Response from API ' + JSON.stringify(response));
    };

    const navigateToDetails = uniqueId => {
        if (profile.Data.Items[0].type === 'Teacher') {
            history.push('/history/teacher-booking/' + uniqueId);
        } else {
            history.push('history/school-booking/' + uniqueId);
        }
    };

    let content;

    if (bookingStatus === 'loading' || profileStatus === 'idle') {
        content = <Loading />;
    } else if (redirectToHome) {
        content = (
            <ProfileWarning
                message="You cannot view History until your profile
        is verified"
                redirectTime={countDown}
            />
        );
    } else if (bookingStatus === 'succeeded' && profile.Data.Count > 0) {
        content = (
            <HistoryTable
                title="History Table"
                rows={rows}
                confirmBooking={confirmBooking}
                navigateToDetails={navigateToDetails}
                type={profile.Data.Items[0].type}
                snackBarMessage={state.snackBarMessage}
                openSnack={state.openSnack}
                snackSeverity={state.snackSeverity}
            />
        );
    } else if (
        (bookingStatus === 'error' || bookingStatus === 'failed') &&
        profile.Data.Count > 0
    ) {
        content = (
            <ErrorLoading
                text="Error Loading Bookings"
                type={profile.Data.Items[0].type}
                dispatchCall={() =>
                    dispatchBookingFromStore(
                        process.env.REACT_APP_scope,
                        profile.Data.Items[0].type
                    )
                }
            />
        );

        // (
        //     <Box
        //         sx={{
        //             margin: 'auto',
        //             marginTop: '24px',
        //             maxWidth: '1200px',
        //             textAlign: 'center',
        //         }}
        //     >
        //         <Alert severity="error"></Alert>
        //         <Button
        //             sx={{ m: 1 }}
        //             variant="contained"
        //             color="secondary"
        //             onClick={
        //             }
        //         >
        //             Refresh
        //         </Button>
        //     </Box>
        // );
    }
    function setNotif(severity, autoHideDuration, description) {
        sendNotification(severity, autoHideDuration, description);
    }
    return (
        <div>
            <Title title="History" />
            <Box
                sx={{
                    margin: 'auto',
                    padding: '16px',
                    backgroundColor: '#FFF',
                    borderRadius: '5px',
                    boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                    maxWidth: '414px',
                }}
            >
                <Typography variant="h5">Date Selection</Typography>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDateRangePicker
                        startText="Start Date"
                        inputFormat="dd/MM/yyyy"
                        value={[state.startDate, state.endDate]}
                        onChange={newValue => {
                            const startFormattedValue = format(
                                newValue[0],
                                'yyyy-MM-dd'
                            );
                            const endFormattedValue = format(
                                newValue[1],
                                'yyyy-MM-dd'
                            );

                            setState({
                                ...state,
                                startDate: startFormattedValue,
                                endDate: endFormattedValue,
                            });
                        }}
                        renderInput={(startProps, endProps) => (
                            <React.Fragment>
                                <TextField
                                    {...startProps}
                                    sx={{ marginTop: '12px' }}
                                />
                                <Box sx={{ mx: 2 }}></Box>
                                <TextField
                                    {...endProps}
                                    sx={{ marginTop: '12px' }}
                                />
                            </React.Fragment>
                        )}
                    />
                </LocalizationProvider>
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <BookingButton
                        color="primary"
                        variant="contained"
                        sx={{ marginTop: '12px' }}
                        onClick={handleSearch}
                    >
                        Search
                    </BookingButton>
                </Box>
            </Box>
            <RootDiv>{content}</RootDiv>
            {signDocsOpen && (
                <SignSchoolDocs
                    setOpen={setSignDocsOpen}
                    schoolDocsInfo={schoolDocsInfo}
                    setNotif={setNotif}
                    confirmBooking={confirmBooking}
                />
            )}
        </div>
    );
};

export default withAuthenticationRequired(History, {
    onRedirecting: () => <Loading />,
});
